module.exports = __webpack_public_path__ + "static/alternatiba-7e14e0273fefb8bb991b9f18f7c896dc.png";